import {useContext} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../../config.js'

export const useTranslateForm = () => {
  const {domain, i18n} = useContext(Context)
  const {formFieldIds} = domain.get('config').get('form')

  const customTranslations = {
    [formFieldIds.dataPrivacyCheckbox]: {
      getCustomLabel: label =>
        htmlStringToReactElement(
          i18n.t(label, {
            linkStart: `<a href="/condiciones-de-uso/#proteccion-datos/" class="${PAGE_BASE_CLASS}-reportAdDrawerComplaintForm-${formFieldIds.dataPrivacyCheckbox}-link" target='_blank'>`,
            linkEnd: '</a>'
          })
        )
    }
  }

  const translateForm = ({fields}) => {
    for (const field of fields) {
      const {hint, label, help, id, constraints, datalist} = field
      if (hint) field.hint = i18n.t(hint, 1)
      if (label) {
        field.label = customTranslations[id]?.getCustomLabel
          ? customTranslations[id].getCustomLabel(label)
          : i18n.t(label, 1)
      }
      if (help) field.help = i18n.t(help, 1)
      if (constraints) {
        constraints.forEach(constraint => {
          if (constraint.message) constraint.message = i18n.t(constraint.message, 1)
        })
      }
      if (datalist) {
        datalist.forEach(datalistItem => {
          datalistItem.text = i18n.t(datalistItem.text, 1)
        })
      }
    }
  }

  return {
    translateForm
  }
}
